import { Box, Drawer, Grid, styled, useTheme } from '@mui/material';
import { useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from 'src/assets/logo/logo.svg';
import Scrollbar from 'src/components/Scrollbar';
import { SidebarContext } from 'src/contexts/SidebarContext';
import SidebarMenu from './SidebarMenu';

const APP_NAME = process.env.REACT_APP_NAME;

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        min-width: ${theme.sidebar.width};
        color: ${theme.colors.alpha.trueWhite[70]};
        position: relative;
        z-index: 7;
        height: calc(100% - 32px);
        margin: 16px;
        border-radius: 20px;
        overflow: hidden;
        overflow-x: hidden !important;
        /* padding-bottom: 25px; */
        
        & * {
          overflow-x: hidden !important;
        }
        
        & .simplebar-track.simplebar-horizontal {
          display: none !important;
          visibility: hidden !important;
          height: 0 !important;
        }
        
        & .simplebar-content-wrapper {
          overflow-x: hidden !important;
        }
        
        & .simplebar-content {
          overflow-x: hidden !important;
        }
        
        & .simplebar-scrollbar.simplebar-visible:before {
          opacity: 0.3;
        }
        
        & .simplebar-placeholder {
          height: 0 !important;
        }
`
);

const AppName = styled(Link)(
  ({ theme }) => `
        text-decoration: none;
`
);

const GridLogo = () => {
  return (
    <Grid container spacing={1.5} alignItems="center" justifyContent="center">
      <Grid item>
        {/* <Logo /> */}
        <img
          // sx={{ width: 50, height: 50 }}
          src={logo}
        />
      </Grid>
      <Grid item>
        {/* <AppName to={'dashboard'}>
          <Typography variant="h3" color={'white'}>
            {APP_NAME}
          </Typography>
        </AppName> */}
      </Grid>
    </Grid>
  );
};

function Sidebar({ isShowed }) {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();
  const theme = useTheme();
  const location = useLocation();

  useEffect(() => {
    const scrollToActiveItem = () => {
      const activeButton = document.querySelector('.MuiButton-root.active');

      if (activeButton) {
        activeButton.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest'
        });
      }
    };

    const timeoutId = setTimeout(scrollToActiveItem, 200);

    return () => clearTimeout(timeoutId);
  }, [location.pathname, sidebarToggle]);

  return (
    <>
      <SidebarWrapper
        sx={{
          display: {
            xs: 'none',
            lg: isShowed ? 'flex' : 'none'
          },
          flexDirection: 'column',
          position: 'fixed',
          left: 0,
          top: 0,
          background: '#fff',
          borderTopRightRadius: '20px',
          borderBottomRightRadius: '20px',
          boxShadow: '4px 0 15px rgba(0, 0, 0, 0.08)',
          '& .simplebar-content-wrapper': {
            overflowX: 'hidden !important'
          },
          '& .simplebar-track.simplebar-horizontal': {
            display: 'none !important'
          }
        }}
      >
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 10,
            background: '#fff',
            borderTopRightRadius: '20px'
          }}
        >
          <Box mt={2.5} mx={2}>
            <GridLogo />
          </Box>
        </Box>
        <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
          <Scrollbar>
            <Box sx={{ pt: 2, pb: 2 }}>
              <SidebarMenu />
            </Box>
          </Scrollbar>
        </Box>
      </SidebarWrapper>
      <Drawer
        sx={{
          boxShadow: `${theme.sidebar.boxShadow}`
        }}
        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
        open={sidebarToggle}
        onClose={closeSidebar}
        variant="temporary"
        elevation={9}
      >
        <SidebarWrapper
          sx={{
            background: '#fff',
            borderTopRightRadius: '20px',
            borderBottomRightRadius: '20px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            display: 'flex',
            flexDirection: 'column',
            '& .simplebar-content-wrapper': {
              overflowX: 'hidden !important'
            },
            '& .simplebar-track.simplebar-horizontal': {
              display: 'none !important'
            }
          }}
        >
          <Box
            sx={{
              position: 'sticky',
              top: 0,
              zIndex: 10,
              background: '#fff',
              borderTopRightRadius: '20px'
            }}
          >
            <Box mt={2.5} mx={2}>
              <GridLogo />
            </Box>
          </Box>
          <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
            <Scrollbar>
              <Box
                sx={{
                  pb: 2,
                  overflowX: 'hidden !important',
                  width: '100%',
                  maxWidth: '100%'
                }}
              >
                <SidebarMenu />
              </Box>
            </Scrollbar>
          </Box>
        </SidebarWrapper>
      </Drawer>
    </>
  );
}

export default Sidebar;
